import { c as _c } from "react/compiler-runtime";
import { EntityName } from 'record-it-time-common/EntityName';
import { TimeTrackingActivity } from '../../../classes/entities/TimeTrackingActivity/timeTrackingActivityTypes';
import { useEntities } from '../../../hooks/entity/useEntities/useEntities';
import { useEntityByIdOrOriginalId } from '../../../hooks/entity/useEntityByIdOrOriginalId';
import { WorkTimeEntryToCreate } from '../../../store/slice/createWorkTimeEntry/createWorkTimeEntrySlice';
export function useCreateWorkTimeEntrySelectActivityPageActivities(workTimeEntryToCreate, parentActivityId) {
  const $ = _c(10);
  const constructionSite = useEntityByIdOrOriginalId(EntityName.ConstructionSite, workTimeEntryToCreate.constructionSiteId);
  const compilations = useEntities(EntityName.TimeTrackingActivityCompilation, "getByUserGroupId", workTimeEntryToCreate.userGroupId);
  const activities = useEntities(EntityName.TimeTrackingActivity, "getByUserGroupId", workTimeEntryToCreate.userGroupId);
  let t0;
  if ($[0] !== compilations || $[1] !== constructionSite) {
    t0 = constructionSite ? compilations.find(c => c.id === constructionSite.compilationId) : compilations[0];
    $[0] = compilations;
    $[1] = constructionSite;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const firstCompilation = t0;
  let t1;
  if ($[3] !== activities || $[4] !== firstCompilation || $[5] !== parentActivityId) {
    let t2;
    if ($[7] !== firstCompilation || $[8] !== parentActivityId) {
      t2 = activity => firstCompilation && activity.compilationId === firstCompilation.id && activity.parentActivityId === parentActivityId;
      $[7] = firstCompilation;
      $[8] = parentActivityId;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    t1 = activities.filter(t2);
    $[3] = activities;
    $[4] = firstCompilation;
    $[5] = parentActivityId;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}